import getConfig from 'next/config'

export const processEnv = (getConfig() || {}).publicRuntimeConfig || {}
